import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AppConfig } from './appconfig';

@Injectable()
export class ConfigService {

    static readonly POLLING_DISABLED_KEY = 'aosdb.pollingDisabled';

    config: AppConfig = {
        theme: 'lara-light-indigo',
        dark: false,
        inputStyle: 'outlined',
        ripple: true,
        pollingDisabled: localStorage.getItem(ConfigService.POLLING_DISABLED_KEY) === 'true'
    };

    private configUpdate = new Subject<AppConfig>();

    configUpdate$ = this.configUpdate.asObservable();

    updateConfig(config: AppConfig) {
        this.config = config;
        // Persist the polling preference so it survives a reload (the rest of the config is in-memory).
        localStorage.setItem(ConfigService.POLLING_DISABLED_KEY, String(!!config.pollingDisabled));
        this.configUpdate.next(config);
    }

    getConfig() {
        return this.config;
    }
}
